import styled from "styled-components";

export const Dim = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;
